module.exports = __webpack_public_path__ + "img/as_2a.a13af4e3.png";